/* @flow */

import React from 'react'

export default function SettingsPage() {
  return (
    <div>
      <h1>Settings</h1>
      <h2>intentionally left blank</h2>
      <div>
        most of the old settings do not really make sense in the context of the
        new dashboard. only add settings we really need.
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/SettingsPage.js